import React from "react";
import { useState, useEffect } from "react";
import "./Tournament.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Cookies from "js-cookie";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export default function AddTournamentForm() {
  const [season, setSeason] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [rules, setRules] = useState("");
  const [prize, setPrize] = useState("");
  const [teamName1, setTeamname1] = useState("");
  const [teamMembers1, setTeammembers1] = useState("");
  const [teamName2, setTeamname2] = useState("");
  const [teamMembers2, setTeammembers2] = useState("");
  const [teamName3, setTeamname3] = useState("");
  const [teamMembers3, setTeammembers3] = useState("");
  const [overallPerformer, setOverallPerformer] = useState("");
  const [bestAttacker, setBestAttacker] = useState("");
  const [postImage1, setPostImage1] = useState("");
  const [postImage2, setPostImage2] = useState("");
  const [postImage3, setPostImage3] = useState("");
  const winners = [];

  const [allDetails, setAllDetails] = useState(true);
  const [buttonText, setButtonText] = useState("Add");
  const navigate = useNavigate();
  const [showA, setShowA] = useState(false);
  const [showB, setShowB] = useState(false);

  const toggleShowA = () => setShowA(!showA);
  const toggleShowB = () => setShowB(!showB);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    }
  }, []);
  const handleFileUpload1 = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    // console.log(base64);
    setPostImage1(base64);
  };

  const handleFileUpload2 = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    // console.log(base64);
    setPostImage2(base64);
  };

  const handleFileUpload3 = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    // console.log(base64);
    setPostImage3(base64);
  };

  function handleseasonChange(event) {
    setSeason(event.target.value);
  }

  function handledateChange(event) {
    setDate(event.target.value);
  }

  function handletimeChange(event) {
    setTime(event.target.value);
  }

  function handlerulesChange(event) {
    setRules(event.target.value);
  }

  function handleprizeChange(event) {
    setPrize(event.target.value);
  }

  function handleteamname1Change(event) {
    setTeamname1(event.target.value);
  }
  function handleteammembers1Change(event) {
    setTeammembers1(event.target.value);
  }
  function handleteamname2Change(event) {
    setTeamname2(event.target.value);
  }
  function handleteammembers2Change(event) {
    setTeammembers2(event.target.value);
  }
  function handleteamname3Change(event) {
    setTeamname3(event.target.value);
  }
  function handleteammembers3Change(event) {
    setTeammembers3(event.target.value);
  }
  function handleperformerChange(event) {
    setOverallPerformer(event.target.value);
  }

  function handleattackerChange(event) {
    setBestAttacker(event.target.value);
  }

  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  async function handleSubmit() {
    if (!season || !date || !time || !rules || !prize) {
      setAllDetails(false);
      return;
    }
    const dte = new Date(date);
    const rulesarray = rules.split("|");
    // console.log(rulesarray);
    const tmarray1 = teamMembers1.split(",");
    const tmarray2 = teamMembers2.split(",");
    const tmarray3 = teamMembers3.split(",");

    setAllDetails(true);
    setButtonText("Adding...");
    let token = Cookies.get("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    await axios
      .post(
        `https://vickygaming.onrender.com/api/v1/tournaments`,
        {
          seasonName: season,
          date: dte,
          time: time,
          rules: rulesarray,
          prizeDetails: prize,
          winners: [
            {
              teamName: teamName1,
              teamMembers: tmarray1,
              teamLogo: postImage1,
              position: 1,
            },
            {
              teamName: teamName2,
              teamMembers: tmarray2,
              teamLogo: postImage2,
              position: 2,
            },
            {
              teamName: teamName3,
              teamMembers: tmarray3,
              teamLogo: postImage3,
              position: 3,
            },
          ],
          overallPerformer: overallPerformer,
          bestAttacker: bestAttacker,
        },
        config
      )
      .then((response) => {
        setButtonText("Add");
        toggleShowB();
      })
      .catch((error) => {
        toggleShowA();
        console.log(error);
      });
  }

  return (
    <section className="addTournament">
      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showA}
          onClose={toggleShowA}
          delay={3000}
          autohide
          bg="danger"
        >
          <Toast.Body>Something went wrong! Please try again later.</Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer
        position="bottom-end"
        className="p-3"
        style={{ zIndex: 1 }}
      >
        <Toast
          show={showB}
          onClose={toggleShowB}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Body>Successfully Added!</Toast.Body>
        </Toast>
      </ToastContainer>

      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "1900px" }}
      >
        {/* style={{ width: "18rem" }} */}
        <Card style={{ width: "100%", margin: "30px" }}>
          <div
            className="card-header text-center text-md-center"
            style={{ borderColor: "#fff" }}
          >
            <h1
              className="mb-1 mt-1"
              style={{ fontSize: "20px", fontWeight: 700 }}
            >
              Add Tournament
            </h1>
          </div>
          <Card.Body className="px-3">
            <Form>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Season
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="season"
                  value={season}
                  placeholder="Season Name"
                  onChange={handleseasonChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Date
                </Form.Label>
                <br />
                <input
                  type="date"
                  name="date"
                  value={date}
                  onChange={handledateChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Time
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="time"
                  value={time}
                  placeholder="9:00 p.m - 10:00 p.m"
                  onChange={handletimeChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Rules
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="rules"
                  value={rules}
                  placeholder="rule1|rule2|rule3"
                  onChange={handlerulesChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Prize Details
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="prize"
                  value={prize}
                  placeholder="Prize details"
                  onChange={handleprizeChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <p style={{ color: "#fff", fontWeight: 700 }}>
                Winners Details(optional)
              </p>
              <p style={{ color: "#fff", fontWeight: 700 }}>1st Prize 🥇</p>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <label
                  htmlFor="photo1"
                  className="form-label"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  Team1 Logo
                </label>
                <br />
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  name="photo1"
                  id="photo1"
                  onChange={(e) => handleFileUpload1(e)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Name
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teamname1"
                  value={teamName1}
                  placeholder="Team Name"
                  onChange={handleteamname1Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Members
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teammembers1"
                  value={teamMembers1}
                  placeholder="member1,member2,member3"
                  onChange={handleteammembers1Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <p style={{ color: "#fff", fontWeight: 700 }}>2nd Prize 🥈</p>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <label
                  htmlFor="photo2"
                  className="form-label"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  Team2 Logo
                </label>
                <br />
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  name="photo2"
                  id="photo2"
                  onChange={(e) => handleFileUpload2(e)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Name
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teamname2"
                  value={teamName2}
                  placeholder="Team Name"
                  onChange={handleteamname2Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Members
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teammembers2"
                  value={teamMembers2}
                  placeholder="member1,member2,member3"
                  onChange={handleteammembers2Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <p style={{ color: "#fff", fontWeight: 700 }}>3rd Prize 🥉</p>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <label
                  htmlFor="photo3"
                  className="form-label"
                  style={{ color: "#fff", fontWeight: 700 }}
                >
                  Team3 Logo
                </label>
                <br />
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  name="photo3"
                  id="photo3"
                  onChange={(e) => handleFileUpload3(e)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Name
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teamname3"
                  value={teamName3}
                  placeholder="Team Name"
                  onChange={handleteamname3Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Team Members
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="teammembers3"
                  value={teamMembers3}
                  placeholder="member1,member2,member3"
                  onChange={handleteammembers3Change}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  OverAll Performer
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="overallperformer"
                  value={overallPerformer}
                  placeholder="performer"
                  onChange={handleperformerChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicseason">
                <Form.Label style={{ color: "#fff", fontWeight: 700 }}>
                  Best Attacker
                </Form.Label>
                <br />
                <input
                  type="text"
                  name="bestattacker"
                  value={bestAttacker}
                  placeholder="attacker"
                  onChange={handleattackerChange}
                  style={{
                    padding: "10px 10px",
                    borderRadius: "5px",
                    border: "none",
                    width: "100%",
                  }}
                />
              </Form.Group>

              {!allDetails && (
                <div
                  className="error"
                  style={{ color: "red", fontSize: "20px", fontWeight: 700 }}
                >
                  Please Enter all the details
                </div>
              )}

              <div className="d-flex align-items-center justify-content-center mt-2 mb-2">
                <Button variant="primary" onClick={handleSubmit}>
                  {buttonText}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </section>
  );
}
